import { reducedMotion } from '../utils/breakpoints.js'

// Purely decorative background video (HomePage hero only, see Hero.ss) - the
// hero image is the real content and shows immediately; this only ever fades
// in on top once it's actually buffered enough to play smoothly, and never
// loads at all if the user prefers reduced motion.
const initHeroVideo = () => {
    const video = document.querySelector('.js-hero-video')
    if (!video) return
    if (reducedMotion.matches) return

    const src = video.dataset.src
    if (!src) return

    video.addEventListener('canplaythrough', () => {
        video.classList.remove('opacity-0')
        video.play().catch(() => {})
    }, { once: true })

    video.src = src
    video.load()
}

// Waiting for `load` (rather than running immediately) keeps this large,
// non-critical fetch from competing with the hero image, fonts, and other
// above-the-fold resources for bandwidth during the critical rendering path -
// HTMLHead.ss's preconnect hint means the connection to Vimeo is already warm
// by the time this fires.
if (document.readyState === 'complete') {
    initHeroVideo()
} else {
    window.addEventListener('load', initHeroVideo, { once: true })
}
